// sensei-app/common/schemas/collections/courses.js
import { z } from "zod";

// Defines a single, scorable topic within a course.
const TopicDefinitionSchema = z.object({
    // FIX: topicId is now optional. The server will generate it if it's missing.
    topicId: z.string().uuid().optional().describe("Unique ID for this topic definition. Auto-generated by the server if not provided."),
    title: z.string().min(1, "Topic title is required."),
    type: z.enum(["class", "assessment", "assignment"]).describe("The type of learning activity."),
    documentPath: z.string().describe("Path to the .md file containing the content (lesson, questions, etc.)."),
    marks: z.number().min(0).describe("The total marks awarded for completing/passing this topic."),
    isMandatory: z.boolean().optional().default(true).describe("If false, this topic is optional and not required for course completion."),
});
const CourseSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    title: z.string().min(1, "Course title is required."),
    description: z.string().optional().nullable(),
    courseAdminId: z.string().optional().nullable(),
    documentInstanceId: z.string().optional().nullable(),

    topics: z.array(TopicDefinitionSchema).optional().default([]),

    passingScore: z.number().min(0).describe("The minimum total score required to pass the course."),

    price: z.number().int().min(0).default(0).describe("The one-time enrollment cost for this course, in the smallest currency unit (e.g., cents)."),
    currency: z.string().length(3).optional().nullable().default('USD').describe("The ISO 4217 currency code for the price."),

    isPublished: z.boolean().default(false),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default CourseSchema;